import httpClient from './httpClient';
import { DEBUG_CONFIG, debugLog } from '../config/debug';

const formulaService = {
  /**
   * Obtener todas las fórmulas sin paginación
   */
  async obtenerFormulas(filtros = {}) {
    try {
      console.log('🔄 formulaService.obtenerFormulas - Iniciando...', filtros);
      
      const params = new URLSearchParams();
      
      // Agregar filtros opcionales
      if (filtros.codigo) {
        params.append('codigo', filtros.codigo);
      }
      if (filtros.id_tipo) {
        params.append('id_tipo', filtros.id_tipo);
      }
      if (filtros.activas) {
        params.append('activas', filtros.activas);
      }
      
      const queryString = params.toString();
      const url = `/formulas${queryString ? `?${queryString}` : ''}`;
      
      console.log('🌐 formulaService - URL:', url);
      
      const response = await httpClient.get(url);
      console.log('✅ formulaService.obtenerFormulas - Respuesta:', response);
      
      return {
        success: true,
        data: response.data,
        total: response.total,
        message: response.message || 'Fórmulas obtenidas exitosamente'
      };
    } catch (error) {
      console.error('❌ formulaService.obtenerFormulas - Error:', error);
      
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error || 
                          error.message || 
                          'Error al obtener fórmulas';
      
      return {
        success: false,
        error: errorMessage,
        data: [],
        total: 0
      };
    }
  },

  /**
   * Obtener una fórmula específica por ID
   */
  async obtenerFormula(id) {
    try {
      console.log('🔄 formulaService.obtenerFormula - ID:', id);
      
      const response = await httpClient.get(`/formulas/${id}`);
      console.log('✅ formulaService.obtenerFormula - Respuesta:', response);
      
      return {
        success: true,
        data: response.data,
        message: response.message || 'Fórmula obtenida exitosamente'
      };
    } catch (error) {
      console.error('❌ formulaService.obtenerFormula - Error:', error);
      
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error || 
                          error.message || 
                          'Error al obtener la fórmula';
      
      return {
        success: false,
        error: errorMessage,
        data: null
      };
    }
  },

  /**
   * Crear una nueva fórmula
   */
  async crearFormula(formulaData) {
    try {
      console.log('🔄 formulaService.crearFormula - Datos:', formulaData);
      
      const response = await httpClient.post('/formulas', formulaData);
      console.log('✅ formulaService.crearFormula - Respuesta:', response);
      
      return {
        success: true,
        data: response.data,
        message: response.message || 'Fórmula creada exitosamente'
      };
    } catch (error) {
      console.error('❌ formulaService.crearFormula - Error:', error);
      
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error || 
                          error.message || 
                          'Error al crear la fórmula';
      
      // Re-lanzar el error con toda la información para manejar validaciones
      throw {
        message: errorMessage,
        response: error.response
      };
    }
  },

  /**
   * Actualizar una fórmula existente
   */
  async actualizarFormula(id, formulaData) {
    try {
      console.log('🔄 formulaService.actualizarFormula - ID:', id, 'Datos:', formulaData);
      
      const response = await httpClient.put(`/formulas/${id}`, formulaData);
      console.log('✅ formulaService.actualizarFormula - Respuesta:', response);
      
      return {
        success: true,
        data: response.data,
        message: response.message || 'Fórmula actualizada exitosamente'
      };
    } catch (error) {
      console.error('❌ formulaService.actualizarFormula - Error:', error);
      
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error || 
                          error.message || 
                          'Error al actualizar la fórmula';
      
      // Re-lanzar el error con toda la información para manejar validaciones
      throw {
        message: errorMessage,
        response: error.response
      };
    }
  },

  /**
   * Eliminar una fórmula
   */
  async eliminarFormula(id) {
    try {
      console.log('🔄 formulaService.eliminarFormula - ID:', id);
      
      const response = await httpClient.delete(`/formulas/${id}`);
      console.log('✅ formulaService.eliminarFormula - Respuesta:', response);
      
      return {
        success: true,
        message: response.message || 'Fórmula eliminada exitosamente'
      };
    } catch (error) {
      console.error('❌ formulaService.eliminarFormula - Error:', error);
      
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error || 
                          error.message || 
                          'Error al eliminar la fórmula';
      
      return {
        success: false,
        error: errorMessage
      };
    }
  },

  /**
   * Obtener códigos PLAME disponibles para fórmulas
   */
  async obtenerCodigosPlame() {
    try {
      console.log('🔄 formulaService.obtenerCodigosPlame - Iniciando...');
      
      const response = await httpClient.get('/formulas/codigos-plame');
      console.log('✅ formulaService.obtenerCodigosPlame - Respuesta:', response);
      
      return {
        success: true,
        data: response.data,
        message: response.message || 'Códigos PLAME obtenidos exitosamente'
      };
    } catch (error) {
      console.error('❌ formulaService.obtenerCodigosPlame - Error:', error);
      
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error || 
                          error.message || 
                          'Error al obtener códigos PLAME';
      
      return {
        success: false,
        error: errorMessage,
        data: []
      };
    }
  },

  /**
   * Obtener regímenes laborales disponibles para fórmulas
   */
  async obtenerRegimenesLaborales() {
    try {
      console.log('🔄 formulaService.obtenerRegimenesLaborales - Iniciando...');
      
      const response = await httpClient.get('/formulas/regimenes-laborales');
      console.log('✅ formulaService.obtenerRegimenesLaborales - Respuesta:', response);
      
      return {
        success: true,
        data: response.data,
        message: response.message || 'Regímenes laborales obtenidos exitosamente'
      };
    } catch (error) {
      console.error('❌ formulaService.obtenerRegimenesLaborales - Error:', error);
      
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error || 
                          error.message || 
                          'Error al obtener regímenes laborales';
      
      return {
        success: false,
        error: errorMessage,
        data: []
      };
    }
  }
};

// Solo exportar logs de debug en desarrollo
if (DEBUG_CONFIG.ENABLE_LOGS) {
  console.log('📦 formulaService cargado correctamente');
}

export default formulaService; 